import * as store from './store';
import { FL_USER_SOURCE } from './constants';

/**
 * @typedef {Object} IdmIdentity
 * @property {string} Type
 * @property {string|number} Id
 */

/**
 * Attempt to derive the userKey from IDM identities.
 * Looks for first identity whose Type is 'employee' or 'EmployeeQA'.
 * @param {any} idmData
 * @returns {string|number|undefined}
 */
function extractIdmUserKey(idmData) {
    const identities = idmData && idmData.identities;
    if (!Array.isArray(identities)) { return undefined; }
    const match = identities.find(id => id && (id.Type === 'employee' || id.Type === 'EmployeeQA'));
    return match && match.Id;
}

/**
 * Attempt to derive userKey from passport data structure.
 * @param {any} passportData
 * @returns {string|number|undefined}
 */
function extractPassportUserKey(passportData) {
    return passportData &&
        passportData.userInfo &&
        passportData.userInfo.person &&
        passportData.userInfo.person.id;
}

/**
 * Returns the FL user object with UserKey added, based on either 'idm-data' or 'passport-data'.
 * Priority: IDM first; if not present falls back to passport.
 * @returns {Object|null} A shallow clone of userContext with UserKey injected, or null if unavailable.
 */
export function createFlUser(flUserSource = null) {
    if (flUserSource === FL_USER_SOURCE.IDM) {
        const idmData = store.get('idm-data');
        if (idmData && idmData.userContext) {
            return Object.assign({}, idmData.userContext, { UserKey: extractIdmUserKey(idmData) });
        }
    }
    if (flUserSource === FL_USER_SOURCE.PASSPORT) {
        const passportData = store.get('passport-data');
        const passportUserContext = passportData &&
            passportData.legacyFormattedData &&
            passportData.legacyFormattedData.userContext;
        if (passportUserContext) {
            return Object.assign({}, passportUserContext, { UserKey: extractPassportUserKey(passportData) });
        }
    }
    return null;
}
